import {
  savedOpportunitySchema,
  type Page,
  type SavedListQuery,
  type SavedOpportunity,
  type SaveOpportunityInput,
} from '@teentack/shared';
import { apiFetch, post } from '@/lib/api-client';
import { fetchPage } from '@/lib/api-page';

export function fetchShortlist(query: Partial<SavedListQuery> = {}): Promise<Page<SavedOpportunity>> {
  return fetchPage('/saved-opportunities', savedOpportunitySchema, query);
}

export async function saveOpportunity(input: SaveOpportunityInput): Promise<SavedOpportunity> {
  return savedOpportunitySchema.parse(await post<unknown>('/saved-opportunities', input));
}

export async function unsaveOpportunity(jobId: string): Promise<void> {
  await apiFetch<void>(`/saved-opportunities/${jobId}`, { method: 'DELETE' });
}
